module.exports = new function sliderFade ()
{

    function fadeSlider (slider, cellTarget, slideClass, slideSpeed) {
        var slides = slider.querySelectorAll(cellTarget);
        var slidesArr = [];
        var slideCount = 0;
        var _this = slidesArr;

        for ( var i = 0; i < slides.length; i++) {
            slidesArr.push(slides[i]);
        };

        // Check if slides exists to prevent errors
        if ( slidesArr.length !== 0 ) {

            _this[0].classList.add(slideClass);

            setInterval(function () {

                // Fade out current item
                _this[slideCount].classList.remove(slideClass);

                // Reset
                slideCount == _this.length - 1 ? slideCount = 0 : slideCount++;

                // Fade in next item
                _this[slideCount].classList.add(slideClass);

            }, slideSpeed);

        }

    };

    const quoteSliders = document.querySelectorAll('.quote-box');

    for (let i = 0; i < quoteSliders.length; i++) {
        fadeSlider(quoteSliders[i], '.quote-box_slide' ,'quote-box_slide_show', 4500);
    }

    const textFader = document.querySelectorAll('.js-text-fade');

    for (let i = 0; i < textFader.length; i++) {
        fadeSlider(textFader[i], '.slide-col' ,'slide-col_show', 4500);
    }

}
